// extracted by mini-css-extract-plugin
export default {"videoContainer":"BenefitsCMSPage_videoContainer__2EDNG","video":"BenefitsCMSPage_video__ny7MS","helperHeaderContainer":"BenefitsCMSPage_helperHeaderContainer__cueYG"};